import React, { FC } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import clsx from "clsx";
import { ChevronIcon } from "./icons";
import { useServiceSelector } from "./useServiceSelector";
import cls from "./styles.module.scss";

const CLOSED_TOGGLE_BOTTOM = 64;
const OPEN_TOGGLE_BOTTOM = 188;

export const ServiceSelector: FC = () => {
  const {
    currentService,
    availableServices,
    open,
    highlightKuper,
    toggle,
    select,
  } = useServiceSelector();
  const reduceMotion = Boolean(useReducedMotion());
  const CurrentServiceIcon = currentService.Icon;
  const menuTransition = reduceMotion
    ? { duration: 0 }
    : { type: "spring" as const, stiffness: 420, damping: 36 };

  return (
    <div className={clsx(cls.servicePicker, open && cls.servicePickerOpen)}>
      <motion.button
        type="button"
        className={cls.menuToggle}
        onClick={toggle}
        aria-label={open ? "Свернуть сервисы" : "Выбрать сервис"}
        aria-expanded={open}
        animate={{ bottom: open ? OPEN_TOGGLE_BOTTOM : CLOSED_TOGGLE_BOTTOM }}
        transition={menuTransition}
      >
        <motion.span
          className={cls.chevron}
          animate={{ rotate: open ? 180 : 0 }}
          transition={
            reduceMotion
              ? { duration: 0 }
              : { type: "spring", stiffness: 500, damping: 34 }
          }
        >
          <ChevronIcon />
        </motion.span>
      </motion.button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            className={cls.expandedServices}
            initial={{ opacity: 0, y: 14, scaleY: 0.92 }}
            animate={{ opacity: 1, y: 0, scaleY: 1 }}
            exit={{ opacity: 0, y: 10, scaleY: 0.94 }}
            transition={menuTransition}
          >
            {availableServices.map(({ id, label, Icon }) => (
              <button
                key={id}
                type="button"
                className={clsx(
                  cls.serviceButton,
                  id === "kuper" && highlightKuper && cls.kuperModalActive
                )}
                onClick={() => select(id)}
              >
                <Icon />
                <span className={cls.serviceLabel}>{label}</span>
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>

      <button
        type="button"
        className={clsx(
          cls.serviceButton,
          cls.currentService,
          currentService.id === "kuper" &&
            highlightKuper &&
            cls.kuperModalActive
        )}
        onClick={toggle}
        aria-pressed="true"
        aria-expanded={open}
      >
        <CurrentServiceIcon />
        <span className={cls.serviceLabel}>{currentService.label}</span>
      </button>
    </div>
  );
};
